import React from "react";
import CartQuantityPicker from "../CartQuantityPicker/CartQuantityPicker";
import "../CheckoutPanel/CheckoutPanel.css";

const SummaryList = ({ items, packages, currency }) => (
  <ul className="summary-list">
    {(items || []).map((cartItem) => {
      const packageId = String(cartItem.internal_package_id || cartItem.id);
      const pkg = packages.find((p) => String(p.id) === packageId);

      if (!pkg) return null;

      const rawCode = pkg.country_id || pkg.region_id;
      const flagCode = rawCode ? String(rawCode).toLowerCase() : "";
      const isRegion = !!pkg.region_id;
      const folder = pkg.country_id ? "flags" : "regions";

      return (
        <li className="summary-item" key={packageId}>
          <div className="summary-item__product">
            <div className="summary-flag-wrapper">
              <img
                className={`summary-flag ${isRegion ? "summary-flag--region" : ""}`}
                src={`${process.env.PUBLIC_URL}/icons/${folder}/${flagCode}.png`}
                alt={`${flagCode} flag`}
              />
            </div>

            <div className="summary-item__info">
              <div className="summary-item__name">{pkg.name}</div>
            </div>
          </div>

          <CartQuantityPicker item={cartItem} />

          <div className="summary-item__price">{currency(pkg.price || 0, pkg.currency)}</div>
        </li>
      );
    })}
  </ul>
);

export default SummaryList;
